import script from "./EntityHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./EntityHeader.vue?vue&type=script&setup=true&lang=js"

import "./EntityHeader.vue?vue&type=style&index=0&id=7006599b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7006599b"]])

export default __exports__